/**
 * Derive the display name for a Source record.
 *
 * Company-linked sources (interview experiences) have name=null and derive
 * their display name from the joined company. Non-company sources use their
 * stored name directly. The Source table enforces name XOR companyId
 * (Source_name_xor_companyId_check), so the fallback only appears when the
 * joined company row is missing (e.g. soft-deleted).
 */
export const UNKNOWN_SOURCE_LABEL = 'Unknown Source'

export function getSourceDisplayNameFromFields(fields: {
  name: string | null | undefined
  companyId: string | null | undefined
  companyName: string | null | undefined
}): string {
  if (fields.companyId && fields.companyName) {
    return `${fields.companyName} Interview Experience`
  }
  return fields.name ?? UNKNOWN_SOURCE_LABEL
}

export function getSourceDisplayName(source: {
  name: string | null
  companyId: string | null
  company?: { name: string } | null
}): string {
  return getSourceDisplayNameFromFields({
    name: source.name,
    companyId: source.companyId,
    companyName: source.company?.name ?? null,
  })
}
